import { ReactNode } from 'react';
import { Container, Box, Alert, AlertTitle } from '@mui/material';
import useAuth from '../hooks/useAuth';
import useFeature from '../hooks/useFeature';
import { FeatureKey } from '../constants/features';
import LoadingScreen from '../components/LoadingScreen';
import Login from '../pages/auth/Login';

// ----------------------------------------------------------------------

type FeatureGuardProps = {
  feature: FeatureKey;
  children: ReactNode | string;
};

export default function FeatureGuard({ feature, children }: FeatureGuardProps) {
  const { isAuthenticated, isInitialized } = useAuth();
  const { isEnabled, isLoaded } = useFeature(feature);

  if (!isInitialized || !isLoaded) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  if (!isEnabled) {
    return (
      <Box sx={{ px: '2', pt: '24px' }}>
        <Container>
          <Alert severity="error">
            <AlertTitle>Feature Not Available</AlertTitle>
            This feature is not available for your company.
          </Alert>
        </Container>
      </Box>
    );
  }

  return <>{children}</>;
}
